import React from "react";
import { Theme } from "./src/theme";
import LanguageProvider from "./src/contexts/languageProvider";

export const wrapRootElement = ({ element }) => {
  return (
    <Theme>
      <LanguageProvider>{element}</LanguageProvider>
    </Theme>
  );
};
